/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SddcQuotaRecord { 
    /**
     * VCF org id
     */
    vcf_org_id?: string;
    effective_sddc_hours?: number;
    /**
     * end timestamp for current period
     */
    end_ts?: Date;
    /**
     * start timestamp for current period
     */
    start_ts?: Date;
    /**
     * timestamp when used sddc hours updated
     */
    usage_updated_ts?: Date;
    used_sddc_hours?: number;
}

